module.exports = __webpack_public_path__ + "img/arrow-charge.053fc001.svg";